import React, { useMemo } from 'react';

import { Menu, MenuItem, IconButton, AddchartIcon } from '@gogame/components';
import { useScreenDispatch, useScreenState } from '@gogame/screens';

import { ADD_CHART, DUPLICATE_CHART } from 'scenes/Trackers/Tracker/reducers';

import { useChartIndex, useChartState } from '../hooks';

export const AddChartAction = () => {
  const screenState = useScreenState();
  const chartState = useChartState();
  const dispatch = useScreenDispatch();
  const chartIndex = useChartIndex();

  const isLast = useMemo(() => {
    return chartIndex === screenState.charts.length - 1;
  }, [chartIndex, screenState.charts.length]);

  const canAdd = useMemo(() => {
    return (
      isLast &&
      screenState.charts.length < 3 &&
      !chartState.annotations.showAnnotations
    );
  }, [
    isLast,
    screenState.charts.length,
    chartState.annotations.showAnnotations,
  ]);

  const onAdd = () => {
    dispatch({
      type: ADD_CHART,
    });
  };

  const onDuplicate = () => {
    dispatch({
      type: DUPLICATE_CHART,
      payload: { index: chartIndex },
    });
  };

  if (!canAdd) {
    return null;
  }

  return (
    <Menu anchor={<IconButton icon={<AddchartIcon />} tooltip={'Add chart'} />}>
      <MenuItem onClick={onAdd}>New chart</MenuItem>
      <MenuItem onClick={onDuplicate}>Duplicate chart</MenuItem>
    </Menu>
  );
};
